import {
  GET_DIAGNOSES,
  GET_CONSULTATION,
  UPDATE_DOCTORS_DATA,
  SET_REMINDER,
  SET_REMINDER_STATUS,
  CHANGE_IMAGE_STATUS,
} from "js/redux/type.js";

const initialState = {
  consultations: [],
  selectedConsultation: {},
  doctors: {},
};

const diagnoses = (state = initialState, action) => {
  switch (action.type) {
    case GET_DIAGNOSES:
      return {
        ...state,
        consultations: action.payload.examinations,
      };
    case GET_CONSULTATION:
      return {
        ...state,
        selectedConsultation: action.payload,
      };
    case UPDATE_DOCTORS_DATA:
      return {
        ...state,
        doctors: {
          ...action.payload,
        },
      };
    case SET_REMINDER:
      return {
        ...state,
        selectedConsultation: {
          ...state.selectedConsultation,
          diagnoses: [
            {
              ...state.selectedConsultation.diagnoses[0],
              ...action.payload,
            },
            ...state.selectedConsultation.diagnoses.slice(1),
          ],
        },
      };
    case SET_REMINDER_STATUS:
      return {
        ...state,
        selectedConsultation: {
          ...state.selectedConsultation,
          ...action.payload,
        },
      };
    case CHANGE_IMAGE_STATUS:
      if (action.payload.isCloseup) {
        return {
          ...state,
          selectedConsultation: {
            ...state.selectedConsultation,
            closeupImages: state.selectedConsultation.closeupImages.map(
              (image) =>
                image.uuid === action.payload.id
                  ? { ...image, is_visible: action.payload.is_visible }
                  : image,
            ),
          },
        };
      } else {
        return {
          ...state,
          selectedConsultation: {
            ...state.selectedConsultation,
            overviewImages: state.selectedConsultation.overviewImages.map(
              (image) =>
                image.uuid === action.payload.id
                  ? { ...image, is_visible: action.payload.is_visible }
                  : image,
            ),
          },
        };
      }

    default:
      return state;
  }
};

export default diagnoses;
